import { toggleModal } from './modal';

document.addEventListener('DOMContentLoaded', function () {
  initDocumentSectionsSelectionModal();
});

function initDocumentSectionsSelectionModal() {
  const documentSectionsSelectionModal = document.querySelector('#documentSectionsSelection-modal');
  if (!documentSectionsSelectionModal)
	return;

  const tableOptions = {
	ajaxURL: '/Templates/DocumentSections/list/?handler=TabulatorList',
	initialSort: [{ column: 'name', dir: 'asc' }],
	paginationSize: 10,
	paginationSizeSelector: [10],
	persistence: {
	  sort: true,
	  filter: false,
	  headerFilter: true,
	  group: false,
	  page: false,
	  columns: false,
	},
	columns: [
	  {
		title: 'Nome', field: 'name',
		headerFilter: 'input',
		responsive: 0
	  },
	  {
		title: '', field: 'id', width: 150,
		headerFilter: false, headerSort: false,
		formatter: 'select-button'
	  }
	]
  };

  let documentSectionSelectionTable;

  documentSectionsSelectionModal.addEventListener('modal.show', (event) => {
	documentSectionSelectionTable = app.tabulator.init('#documentSectionsSelection-table', tableOptions);

	documentSectionSelectionTable.on('dataProcessed', function () {
	  documentSectionsSelectionModal
		.querySelectorAll('[data-select-button]')
		.forEach((btn) => {
		  btn.addEventListener('click', (event) => {
			let customEvent = new CustomEvent('documentsectionselected',
			  {
				bubbles: true,
				detail: {
				  status: 'SELECTED',
				  documentSectionId: event.currentTarget.dataset.selectButton
				}
			  });
			document.dispatchEvent(customEvent);
			toggleModal(documentSectionsSelectionModal);
		  });
		});
	});
  });

  documentSectionsSelectionModal.addEventListener('modal.hide', function (event) {
	let customEvent = new CustomEvent('documentsectionselected',
	  {
		bubbles: true,
		detail: { status: 'CANCELED' }
	  });
	document.dispatchEvent(customEvent);
	documentSectionSelectionTable.destroy();
  });

}
